import React from 'react'
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-10 workSans">
      <div className="container mx-auto px-6 grid md:grid-cols-3 gap-8">
        {/* About Section */}
        <div>
          <h3 className="text-xl font-semibold mb-4">About Us</h3>
          <p className="text-sm text-gray-400">
            We are dedicated to providing insightful legal articles and expert legal solutions for various cases. Our goal is to keep you informed and protected.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2">
            <li><a href="/" className="hover:underline">Home</a></li>
            <li><a href="/insights" className="hover:underline">Articles</a></li>
            <li><a href="contact" className="hover:underline">Contact Us</a></li>
            <li><a href="/services" className="hover:underline">Legal Practices</a></li>
          </ul>
        </div>

        {/* Contact & Social Links */}
        <div>
          <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
          <p className="text-sm text-gray-400">
            No. 12 Thomas Laniyan Street, Anthony, Lagos State <br />
            Lagos, NY 10001 <br />
            Phone: +234-9025525239 <br />
            Email: info@lawberonlegals.com
          </p>
          {/* Social Media Links */}
          <div className="flex space-x-4 mt-4">
            <a href="/" target='_blank' className="text-gray-400 hover:text-red-500">
              <FaFacebookF />
            </a>
            <a href="/" target='_blank' className="text-gray-400 hover:text-red-500">
              <FaTwitter />
            </a>
            <a href="/" target='_blank' className="text-gray-400 hover:text-red-500">
              <FaLinkedinIn />
            </a>
            <a href="/" target='_blank' className="text-gray-400 hover:text-red-500">
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="border-t border-gray-700 mt-8 pt-4 text-center text-sm text-gray-400">
        © {new Date().getFullYear()} Lawberon Legals. All Rights Reserved.
      </div>
    </footer>
  )
}

export default Footer;
